module.exports = __webpack_public_path__ + "static/media/LandSt.f39bc580.JPG";